module.exports = __webpack_public_path__ + "img/inchis.3fe3d4f0.jpg";